import React, { Component } from "react";
import { connect } from 'react-redux'

//component
import { Upload, Icon } from 'antd';
import Button from "../../../Buttons";

// helper
import typo from "../../../../constants/dictionaries";
import Api_dms from '../../../../api/api.dms'
import { TypeFiles, MESSAGE } from '../../../../constants/dictionaries'
import message from '../../../../components/Messages'
import Api_tnn from "../../../../api/api.tnn";

class UpFile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fileList: []
        }
    }

    handleRemove = info => {
        this.setState({ fileList: [] });
        this.props.parentHandle([])
        new Api_tnn().DeleteExcelKQQT({ token: this.props.user.access_token, filename: info.fileName})

    };

    customRequest = (options) => {
        var data = new FormData()
        data.append('file', options.file)
        if (TypeFiles.includes(options.file.type)) {
            this.uploadFile(data)
        } else {
            message.error("File " + options.file.name + " không hỗ trợ định dạng")
        }
    }

    uploadFile = (data) => {
        new Api_tnn().UploadFile({ token: this.props.user.access_token, data: data })
        .then((res) => {
            this.setState({
                fileList: [{...res.result,uid: 1, status: "done"}]
            })
            this.props.parentHandle([{...res.result,uid: 1, status: "done"}])
        })
    }

    render() {
        return (
            <Upload accept=".xlsx" onRemove={this.handleRemove} customRequest={this.customRequest} multiple={false} fileList={this.state.fileList}>
                <Button style={{ marginTop: 10 }}>
                    <Icon type="upload" />{typo.cscore_upload_excel}
                </Button>
            </Upload>
        )
    }
}
const mapStateToProps = (state) => ({ user: state.oidc.user });
export default connect(mapStateToProps)(UpFile);